let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b8qNF")).then(() => parcelRequire('gXYPD'));